/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Logger from '@/services/Logger'
import { initStore } from '@/store'
import { loadLanguageAsync, i18n } from '@/i18n'

export function init ({ ctx, store, route }) {
  Logger.debug('store middleware')
  if (store.state.storeConfig.config && store.state.storeConfig.config.code) {
    // Store is set exit
    Logger.debug('store exist -> skip logic')
    return
  }
  // load catalog
  store.commit('ui/setCodeLang', route.params.lang)
  initStore(route, store)
  // load menu items
  return store.dispatch('storeConfig/load', { fullPath: `${store.state.storeConfig.host}${route.fullPath}` }).then(() => {
    /**
     * load new languages
     */
    const ajaxLanguage = loadLanguageAsync(i18n.locale, store.state.ui.storeViewCode, store.state.ui.locale).then(messages => {
      store.commit('ui/messagesLocale', messages)
    })
    if (!process.client) {
      store.commit('ui/saveMenu', [])
      store.commit('cms/cleanContents')
    }
    return Promise.all([
      ajaxLanguage,
      store.dispatch('ui/loadMenu')
    ])
  })
}
